module.exports = __webpack_public_path__ + "img/Frame-87.d18dff94.svg";